export default function onVisitPage({ navigate }) {
  return function (path: string): void {
    navigate(path);
  };
}
